import { fetchFeaturebaseJwt } from '@query'
import { isFeaturebaseEnabled } from '@utils'
import { useQuery } from '@tanstack/react-query'

export const useFeaturebaseWishlistUrl = (featurebaseUrl: string): string => {
  const featurebaseEnabled = isFeaturebaseEnabled()
  const { data } = useQuery({
    queryKey: ['featurebase_wishlist_jwt'],
    queryFn: () => fetchFeaturebaseJwt(),
    enabled: featurebaseEnabled,
    retry: false,
    staleTime: 1000 * 60 * 50,
    refetchOnWindowFocus: false
  })

  if (!featurebaseEnabled || !data?.token) {
    return featurebaseUrl
  }

  try {
    const url = new URL(featurebaseUrl)
    url.searchParams.set('jwt', data.token)
    return url.toString()
  } catch {
    return featurebaseUrl
  }
}
